import React,{useState} from 'react';
import {optionalDeliverables,formatPrice} from '../data/quoteData';
import SectionHeader from './SectionHeader';

function sanitizePrice(value) {
  return value.replace(/[^\d.]/g,'').replace(/(\..*)\./g,'$1');
}

function BuilderOptions({items,onItemsChange,disabled=false}) {
  const [editingId,setEditingId]=useState(null);
  const [draft,setDraft]=useState({name: '',price: ''});
  const currentItems=items || optionalDeliverables;

  const startEditing=(item)=> {
    if (disabled) {
      return;
    }

    setEditingId(item.id);
    setDraft({name: item.name,price: String(item.price)});
  };

  const cancelEditing=()=> {
    setEditingId(null);
    setDraft({name: '',price: ''});
  };

  const saveEditing=()=> {
    if (disabled) {
      return;
    }

    const currentItem=currentItems.find((item)=> item.id===editingId);

    if (!currentItem) {
      cancelEditing();
      return;
    }

    const parsedPrice=Number.parseFloat(draft.price);
    const nextPrice=Number.isFinite(parsedPrice) && parsedPrice >=0
      ? parsedPrice
      : currentItem.price;

    onItemsChange((current)=> current.map((item)=> item.id===editingId
      ? {
        ...item,
        name: draft.name.trim() || item.name,
        price: nextPrice
      }
      : item
    ));

    cancelEditing();
  };

  const toggle=(id)=> {
    if (disabled) {
      return;
    }

    onItemsChange((current)=> current.map((item)=> item.id===id
      ? {...item,enabled: !item.enabled}
      : item
    ));
  };

  return (
    <section className="builder-section">
      <SectionHeader
        description="Choose which optional items are offered with this quote."
        eyebrow="Optional Additional Deliverables"
        title="Client options"
      />

      <div className="builder-options">
        {currentItems.map((item)=> {
          const isEditing=editingId===item.id;

          return (
            <div
              className={`builder-option ${item.enabled ? '' : 'is-disabled'}`}
              key={item.id}
            >
              <button
                aria-label={`${item.enabled ? 'Disable' : 'Enable'} ${item.name}`}
                className={`switch ${item.enabled ? 'on' : ''}`}
                disabled={disabled}
                onClick={()=> toggle(item.id)}
                type="button"
              >
                <span />
              </button>

              {isEditing ? (
                <input
                  aria-label="Deliverable name"
                  disabled={disabled}
                  onChange={(event)=> setDraft((current)=> ({
                    ...current,
                    name: event.target.value
                  }))}
                  style={{
                    minHeight: '34px',
                    padding: '7px 9px',
                    border: '1px solid #cbc8c0',
                    borderRadius: '2px',
                    fontSize: '13px'
                  }}
                  value={draft.name}
                />
              ) : (
                <span className="builder-option__name">{item.name}</span>
              )}

              {isEditing ? (
                <input
                  aria-label="Deliverable price"
                  disabled={disabled}
                  inputMode="decimal"
                  min="0"
                  onChange={(event)=> setDraft((current)=> ({
                    ...current,
                    price: sanitizePrice(event.target.value)
                  }))}
                  step="0.01"
                  style={{
                    minHeight: '34px',
                    padding: '7px 9px',
                    border: '1px solid #cbc8c0',
                    borderRadius: '2px',
                    fontSize: '13px',
                    textAlign: 'right'
                  }}
                  type="text"
                  value={draft.price}
                />
              ) : (
                <strong>{formatPrice(item.price)}</strong>
              )}

              {isEditing ? (
                <span style={{display: 'grid',gap: '3px'}}>
                  <button
                    className="text-button"
                    disabled={disabled}
                    onClick={saveEditing}
                    type="button"
                  >
                    Save
                  </button>
                  <button
                    className="text-button"
                    disabled={disabled}
                    onClick={cancelEditing}
                    type="button"
                  >
                    Cancel
                  </button>
                </span>
              ) : (
                <button
                  className="text-button"
                  disabled={disabled}
                  onClick={()=> startEditing(item)}
                  type="button"
                >
                  Edit
                </button>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default BuilderOptions;